<template>
  <section v-if="showSignalSummary" class="chips-card">
    <p class="chips-card__label">Signal and action summary</p>
    <div class="chips-card__row">
      <span v-if="signalStrengthLabel" class="chip-wrapper">
        <span class="report-chip report-chip--signal">{{ signalStrengthLabel }}</span>
        <span v-if="signalStrengthExplanation" class="chip-tooltip">{{ signalStrengthExplanation }}</span>
      </span>
      <span v-if="actionStatusLabel" class="chip-wrapper">
        <span class="report-chip report-chip--action">{{ actionStatusLabel }}</span>
        <span v-if="actionStatusExplanation" class="chip-tooltip">{{ actionStatusExplanation }}</span>
      </span>
    </div>
    <div v-if="signalStrengthExplanation || actionStatusExplanation" class="chips-card__explanations">
      <p v-if="signalStrengthExplanation" class="chips-card__explanation-line">
        <strong>{{ signalStrengthLabel }}:</strong> {{ signalStrengthExplanation }}
      </p>
      <p v-if="actionStatusExplanation" class="chips-card__explanation-line">
        <strong>{{ actionStatusLabel }}:</strong> {{ actionStatusExplanation }}
      </p>
    </div>
    <p v-if="managerReviewNote" class="chips-card__review-note">{{ managerReviewNote }}</p>
  </section>
</template>

<script>
export default {
  name: 'AskReportChips',
  props: {
    reportView: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    signalStrengthLabel() {
      return String(this.reportView?.signalAndActionSummary?.signalStrengthLabel || '').trim()
    },
    signalStrengthExplanation() {
      return String(this.reportView?.signalAndActionSummary?.signalStrengthExplanation || '').trim()
    },
    actionStatusLabel() {
      return String(this.reportView?.signalAndActionSummary?.actionStatusLabel || '').trim()
    },
    actionStatusExplanation() {
      return String(this.reportView?.signalAndActionSummary?.actionStatusExplanation || '').trim()
    },
    managerReviewNote() {
      return String(this.reportView?.signalAndActionSummary?.managerReviewNote || '').trim()
    },
    showSignalSummary() {
      return Boolean(this.signalStrengthLabel || this.actionStatusLabel)
    },
  },
}
</script>

<style lang="scss" scoped>
.chips-card {
  border: 1px solid $color-border;
  border-radius: $radius-md;
  background: $color-surface;
  padding: $space-3;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.03);
  display: flex;
  flex-direction: column;
  gap: $space-2;
}

.chips-card__label {
  margin: 0;
  font-size: $font-size-xs;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: $color-text-strong;
}

.chips-card__row {
  display: flex;
  flex-wrap: wrap;
  gap: $space-2;
}

.chip-wrapper {
  position: relative;
  display: inline-flex;
}

.report-chip {
  display: inline-flex;
  align-items: center;
  min-height: 1.9rem;
  padding: 0 $space-2;
  border-radius: 999px;
  font-size: $font-size-xs;
  font-weight: 700;
  cursor: help;
}

.report-chip--signal {
  background: rgba(124, 58, 237, 0.12);
  color: $color-primary-dark;
}

.report-chip--action {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}

.chip-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + #{$space-2});
  z-index: 5;
  width: min(280px, 70vw);
  padding: $space-2 $space-3;
  border-radius: $radius-md;
  background: rgba(11, 17, 32, 0.96);
  color: white;
  font-size: $font-size-sm;
  font-weight: 500;
  line-height: 1.4;
  box-shadow: 0 10px 24px rgba(11, 17, 32, 0.22);
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(4px);
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
  pointer-events: none;
}

.chip-tooltip::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgba(11, 17, 32, 0.96) transparent transparent transparent;
}

.chip-wrapper:hover .chip-tooltip,
.chip-wrapper:focus-within .chip-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.chips-card__explanations {
  display: flex;
  flex-direction: column;
  gap: $space-1;
  padding-top: $space-1;
  border-top: 1px solid $color-border;
}

.chips-card__explanation-line {
  margin: 0;
  font-size: $font-size-sm;
  line-height: 1.5;
  color: $color-text-muted;
}

.chips-card__review-note {
  margin: 0;
  font-size: $font-size-sm;
  font-weight: 600;
  color: $color-text-strong;
}
</style>
